import { ChevronRightIconComponent } from '../../../shared/components/icons/chevron-right-icon.component';
import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  ViewChild,
  inject,
  ChangeDetectorRef,
} from '@angular/core';
import {
  InverterType,
  PlantTypeEnum,
  Stats,
  StatsData,
} from '../../../shared/models/stats';
import { BaseComponent } from '../../../base/components/base.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { DateUtils } from '../../../shared/utils/date_utils';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { StringInfoComponent } from '../../../shared/components/string-info/string-info.component';
import { NoxDialogComponent } from '../../../shared/components/nox-dialog/nox-dialog.component';
import {
  NoxDialogParam,
  NoxDialogType,
} from '../../../shared/models/nox-dialog-param';
import { ProductService } from '../../../shared/service/product.service';
import { PlantDetail } from '../../../shared/models/plant';
import { NoxAlertType, PhaseItemList, phaseList } from '../../../shared/models/enum';
import { NoxDatePipe } from '../../../shared/pipe/nox-date.pipe';

import { ClickableDirective } from "../../../shared/directives/clickable.directive";
import { DetailedInfoComponent } from '../../../shared/components/detailed-info/detailed-info.component';
import { ClickOutsideDirective } from '../../../shared/utils/click.outside.directive';
@Component({
  selector: 'app-energy-flow',
  templateUrl: './energy-flow.component.html',
  styleUrl: './energy-flow.component.scss',
  imports: [
    TranslateModule,
    CommonModule,
    MatDialogModule,
    StringInfoComponent,
    NoxDatePipe,
    ClickableDirective,
    DetailedInfoComponent,
    ClickOutsideDirective,
    ChevronRightIconComponent
  ]
})
export class EnergyFlowComponent extends BaseComponent implements OnInit, OnChanges {


  solarPower!: number;
  stringInfo: boolean = false;
  phaseList: PhaseItemList[] = [...phaseList];

  getNumber(value: any): number {
    return Number(value) || 0;
  }

  calculateBatteryProgress(arg0: Stats | undefined) {
    let percent = 0;
    if (Number(arg0?.batteryState) === 0) {
      if (Number(arg0?.discharge) > 1 || Number(arg0?.discharging_current)) {
        percent = Number(arg0?.battery_discharge_percentage);
      } else {
        percent = Number(arg0?.battery_charge_percentage);
      }
    } else {
      percent = Number(arg0?.battery_charge_percentage);
    }
    return percent + '%';
  }
  getState(arg0: Stats | undefined) {
    if (Number(arg0?.discharge) > 1 || Number(arg0?.discharging_current)) {
      return 'Discharging';
    } else {
      return 'Charging';
    }
  }
  @Input() statData?: StatsData;
  @Input() plantName?: string;
  selectedPlant?: PlantDetail | null;
  plantType = PlantTypeEnum;
  inverterType = InverterType;
  animationFlow: AnimationFlow = new AnimationFlow();
  isDeviceOffline: boolean = true;
  noxAlert?: NoxAlertType | null;
  alertType = NoxAlertType;
  dialog = inject(MatDialog);
  isOpen = false;
  productService = inject(ProductService);

  @ViewChild(StringInfoComponent) sideSheet!: StringInfoComponent;
  @ViewChild(DetailedInfoComponent) detailedInfoSidesheet!: DetailedInfoComponent;
  toggleSidebar() {
    this.isOpen = !this.isOpen;
  }
  currentIndex = 0;
  constructor(private readonly cdr: ChangeDetectorRef) {
    super()
  }
  ngOnInit(): void {

    this.productService.selectedPlant.subscribe((plant) => {
      this.selectedPlant = plant;
    });

    if (this.statData?.inverterType == this.inverterType.THINKPOWERHESM) {
      this.solarPower = Number.parseFloat(this.statData.stats.solar_power)

    }
    if (this.statData?.inverterType == this.inverterType.THINKPOWERHESM || this.statData?.inverterType == this.inverterType.GTI || this.statData?.inverterType == this.inverterType.ThinkPower) {
      this.showStringInfo();
    }
    setInterval(() => {
    
      this.currentIndex = (this.currentIndex + 1) % this.phaseList.length;
      this.cdr.detectChanges();
    }, 3000);
  }


  showStringInfo(): void {
    this.stringInfo = false;

    const statData = this.statData;
    if (!statData) {
      return;
    }

    if (statData.deviceId.startsWith('i')) {
      this.stringInfo = Number(statData.inverterRating) <= 25;
    } else if (statData.deviceId.startsWith('sn')) {
      this.stringInfo = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.animationFlow = new AnimationFlow();

    this.noxAlert = null;
    if (this.checkDeviceOffline()) {
      this.isDeviceOffline = true;
    } else {
      this.isDeviceOffline = false;
      if (this.statData?.doubleBlocker) {
        this.buildAlertBlocker(this.statData.doubleBlocker);
      } else {
        this.createAnimationFlow();
      }
    }
  }
  /**
   * Alert Blocker
   * @param doubleBlocker
   */
  buildAlertBlocker(doubleBlocker: string) {
    switch (doubleBlocker) {
      case NoxAlertType.SHORT_CIRCUIT:
        this.noxAlert = NoxAlertType.SHORT_CIRCUIT;
        break;
      case NoxAlertType.INVERTER_OVERHEATED:
        this.noxAlert = NoxAlertType.INVERTER_OVERHEATED;
        break;
      case NoxAlertType.SHORT_CIRCUIT_AND_INVERTER_OVERHEATED:
        this.noxAlert = NoxAlertType.SHORT_CIRCUIT_AND_INVERTER_OVERHEATED;
        break;

      case NoxAlertType.OFFLINE:
        this.isDeviceOffline = true;
        break;

    }
  }
  /**
   *
   * @returns boolean
   */
  private checkDeviceOffline(): boolean {
    if (!this.statData?.stats) {
      return true;
    }
    // Current timestamp
    const currentTime: number = Date.now();

    // Response timestamp
    const responseTime: number =
      this.statData?.stats.last_updated_timestamp * 1000;

    // Difference in hours
    const hours: number = DateUtils.calculateHoursDifference(
      currentTime,
      responseTime,
    );

    // If offline for more than 1 hour, short circuit and turn off wifi
    if (hours > 1) {
      return true;
    }
    return false;
  }

  /**
   * Create Animation Flow
   */
  createAnimationFlow() {

    if (this.statData) {
      switch (this.statData.animationFlow) {
        case '1.1':
        case '2.1':
        case '3.1':
        case '4.1':
        case '13.2':
        case '10.2':
        case '15.6':
          this.animationFlow.solarToCenter = true;
          this.animationFlow.centerToHome = true;
          break;
        case '1.2':
        case '2.2':
        case '3.2':
        case '4.2':
        case '13.3':
        case '15.11':
          this.animationFlow.solarToCenter = true;
          this.animationFlow.centerToHome = true;
          this.animationFlow.centerToBattery = true;
          break;
        case '1.3':
        case '2.3':
        case '3.3':
        case '4.3':
        case '13.4':
        case '15.14':
          this.animationFlow.solarToCenter = true;
          this.animationFlow.centerToHome = true;
          this.animationFlow.batteryToCenter = true;
          break;
        case '1.4':
        case '2.4':
        case '3.4':
        case '4.4':
        case '6.2':
        case '7.2':
        case '13.5':
        case '9.2':
        case '14.2':
        case '15.2':
          this.animationFlow.batteryToCenter = true;
          this.animationFlow.centerToHome = true;
          break;
        case '1.5':
        case '2.5':
        case '3.5':
        case '4.5':
        case '6.3':
        case '7.3':
        case '13.6':
        case '10.3':
        case '9.3':
        case '14.3':
        case '15.3':
          this.animationFlow.gridToCenter = true;
          this.animationFlow.centerToHome = true;
          break;
        case '1.7':
        case '2.7':
        case '3.7':
        case '4.7':
        case '6.4':
        case '7.4':
        case '13.7':
        case '9.4':
        case '14.4':
        case '15.4':
          this.animationFlow.gridToCenter = true;
          this.animationFlow.centerToBattery = true;
          this.animationFlow.centerToHome = true;
          break;

        case '1.8':
        case '2.8':
        case '3.8':
        case '4.8':
        case '13.8':
        case '15.7':

          this.animationFlow.solarToCenter = true;
          this.animationFlow.centerToBattery = true;
          break;
        case '4.9':
        case '6.5':
        case '13.9':
        case '9.5':
        case '14.5':
        case '15.5':
          this.animationFlow.gridToCenter = true;
          this.animationFlow.centerToBattery = true;
          break;
        case '1.11':
        case '2.11':
        case '3.11':
        case '4.11':
        case '13.10':
        case '15.13':
          this.animationFlow.solarToCenter = true;
          this.animationFlow.centerToBattery = true;
          this.animationFlow.gridToCenter = true;
          this.animationFlow.centerToHome = true;
          break;
        case '1.12':
        case '2.12':
        case '3.12':
        case '13.11':
        case '15.15':

          this.animationFlow.solarToCenter = true;
          this.animationFlow.gridToCenter = true;
          this.animationFlow.centerToHome = true;
          break;
        case '4.12':
        case '13.12':
        case '15.9':
          this.animationFlow.solarToCenter = true;
          this.animationFlow.centerToBattery = true;
          this.animationFlow.centerToGrid = true;
          this.animationFlow.centerToHome = true;
          break;
        case '4.13':
        case '13.13':
        case '15.10':
          this.animationFlow.solarToCenter = true;
          this.animationFlow.centerToBattery = true;
          this.animationFlow.centerToGrid = true;
          break;
        case '4.14':
        case '5.1':
        case '13.14':
        case '10.5':
        case '15.8':
          this.animationFlow.solarToCenter = true;
          this.animationFlow.centerToGrid = true;
          break;
        case '4.15':
        case '13.15':
        case '10.6':
        case '15.12':

          this.animationFlow.solarToCenter = true;
          this.animationFlow.centerToHome = true;
          this.animationFlow.centerToGrid = true;
          break;
        case '13.16':
        case '15.16':
          this.animationFlow.solarToCenter = true;
          this.animationFlow.centerToHome = true;
          this.animationFlow.centerToGrid = true;
          this.animationFlow.batteryToCenter = true;
          break;

        case '10.4':
          this.animationFlow.solarToCenter = true;
          this.animationFlow.centerToHome = true;
          this.animationFlow.gridToCenter = true;
          this.animationFlow.centerToHome = true;
          break;
        case '15.17':
          this.animationFlow.batteryToCenter = true;
          this.animationFlow.centerToGrid = true;
          break;
        case '15.18':
          this.animationFlow.batteryToCenter = true;
          this.animationFlow.centerToHome = true;
          this.animationFlow.centerToGrid = true;
          break;
        default:
          break;

      }
    }
  }
  getGridBorderClass(): string {
  const gridState = this.statData?.stats?.grid_state?.toString();
 
  if (this.statData?.inverterType === this.inverterType.ARCTIC_HYBRID) {
    return gridState === '0'
      ? 'border-light-green-variant-1'
      : 'border-light-red-variant-1';
  }
 
  return gridState === '0'
    ? 'border-light-red-variant-1'
    : 'border-light-green-variant-1';
}

  stringInfoDialog() {
    const dialogRef = this.dialog.open(StringInfoComponent);

    dialogRef.afterClosed().subscribe((result) => { });
  }
 
  openDialog() {
    let noxDialogData: NoxDialogParam = {
      type: NoxDialogType.none,
      title: 'Please check the following items',
      messageList: [
        'Ensure that your device is powered on.',
        'Check the functionality of the router connected to your device. ',
        'Check if the router has internet connection.',
        'Confirm your device is in range of the router. ',
        'Confirm the signal strength is good, or if any obstruction is affecting data transmission.',
        "Confirm whether the wifi router's name or password has been changed. If yes, then please Re-Configure the device. ",
      ],
      disclaimer:
        "During configuration, ensure you have the latest ConnectX app installed and that you're near the device with a strong WiFi signal.",
    };
    this.dialog.open(NoxDialogComponent, {
      data: noxDialogData,
      panelClass: 'dialog-color',
    });
  }
  clickOutside() {
    this.detailedInfoSidesheet.isOpen = false
  }
}
class AnimationFlow {
  solarToCenter: boolean = false;
  centerToHome: boolean = false;
  centerToBattery: boolean = false;
  batteryToCenter: boolean = false;
  gridToCenter: boolean = false;
  centerToGrid: boolean = false;
  centerToLoad: boolean = false;
}
